import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VisitenkarteIhresHauses from "./sections/VisitenkarteIhresHauses";
import UnsereExpertise from "./sections/UnsereExpertise";
import ReinigungBeiNacht from "./sections/ReinigungBeiNacht";
import AdditionalServicesOverview from "./sections/AdditionalServicesOverview";
import ServiceAreaAndTrust from "./sections/ServiceAreaAndTrust";
import JetztKontaktAufnehmen from "./sections/JetztKontaktAufnehmen";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VisitenkarteIhresHauses />
      <UnsereExpertise />
      <ReinigungBeiNacht />
      <AdditionalServicesOverview />
      <ServiceAreaAndTrust />
      <JetztKontaktAufnehmen />
      <Footer />
    </div>;
}